import { render, staticRenderFns } from "./zoom.vue?vue&type=template&id=2b38d44e&"
import script from "./zoom.vue?vue&type=script&lang=js&"
export * from "./zoom.vue?vue&type=script&lang=js&"
import style0 from "./zoom.vue?vue&type=style&index=0&lang=scss&scope=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports